import React from "react";
import Select from "react-select";

const MonthPicker = ({
  selectedYear,
  selectedMonth,
  onYearChange,
  onMonthChange,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2019 + 2 }, (_, i) => ({
    value: currentYear + 1 - i,
    label: currentYear + 1 - i,
  })); // De l'année suivante à 2019

  const months = [
    { value: 0, label: "January" },
    { value: 1, label: "February" },
    { value: 2, label: "March" },
    { value: 3, label: "April" },
    { value: 4, label: "May" },
    { value: 5, label: "June" },
    { value: 6, label: "July" },
    { value: 7, label: "August" },
    { value: 8, label: "September" },
    { value: 9, label: "October" },
    { value: 10, label: "November" },
    { value: 11, label: "December" },
  ];

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: 50, // Hauteur maximale du dropdown
      backgroundColor: "#f1f1f1",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "lightgray" : "#f1f1f1",
      color: "black",
    }),
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "800px",
        paddingLeft: "40px",
        marginTop: "20px",
      }}
    >
      <div style={{ width: "150px", marginRight: "20px" }}>
        <Select
          value={years.find((year) => year.value === selectedYear)}
          onChange={(option) => onYearChange(option.value)}
          options={years}
          styles={customStyles}
        />
      </div>
      <div style={{ width: "200px", marginRight: "20px" }}>
        <Select
          value={months.find((month) => month.value === selectedMonth)}
          onChange={(option) => onMonthChange(option.value)}
          options={months}
          styles={customStyles}
        />
      </div>
      <div style={{ display: "flex", alignItems: "center", width: "auto" }}>
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: "green",
            // marginRight: "5px",
          }}
        />
        <span
          style={{ marginRight: "20px", width: "100px", paddingLeft: "5px" }}
        >
          Today's date
        </span>
        <div
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: "red",
            marginRight: "5px",
          }}
        />
        <span style={{ width: "200px" }}>Discharges</span>
      </div>
    </div>
  );
};

export default MonthPicker;
